module.exports = __webpack_public_path__ + "img/csr3.75d07ac7.jpg";